import FavouriteIndicator from './favouriteIndicator'

export default FavouriteIndicator
